<!-- 热门评论索引页 -->
<template>
  <div>
    <van-nav-bar
      :title="title"
      left-text=""
      right-text=""
    />
    <HotComments
      :slug="slug"
      :limit="0"
      @gotHotComments="gotHotComments"
    />
  </div>
</template>

<script>
  import HotComments from './hot-comments.vue'
  import Vue from 'vue'
  import { NavBar } from 'vant'
  Vue.use(NavBar)
  export default {
    name: "HotCommentsList",
    components: {
      HotComments
    },
    data () {
      return {
        slug: '', // show 的 slug
        title: '热评'
      }
    },
    methods: {
      gotHotComments (count) {
        this.title = `热评 ${count} 条`
      }
    },
    mounted () {
      this.slug = this.$route.params.slug
    }
  }
</script>

<style lang="css" scoped>
</style>
